export default __webpack_public_path__ + "static/media/paulina.d8e4e925.png";